import * as React from 'react';
import { getAttributeDefinitions, displayAttributeDefinitions } from '../../helpers/products';
import { observer } from 'mobx-react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import Attributes from '../../components/Query/Attributes/FilterableAttributes';
import { getImageFromProductByVariant } from '../../helpers/getImageFromProductByVariant';
import { IProduct } from '../../interfaces/interfaces';
import QuantityForm from '../../modules/Form/Quantity';
import { Icon, Loader } from '../../modules/modules';
import CartService from '../../services/CartService';
import { CurrencyFormatter as Currency } from '../../utils/utils';
import FullVariants from '../Query/Products/FullVariants';
import { adopt } from 'react-adopt';
import Image from '../Image';
import CountryService from '../../services/CountryService';
import Availability from '../Availability';
import { buildProductLink } from '../../pages/ProductDetail/ProductDetailPage';
import { vatDescription } from '../../helpers/vatDescription';
import { removeUnavailableItemsFromCart } from '../../helpers/removeUnavailableItemsFromCart';

const PRODUCT_STATUS_AVAILABLE = 'Skladem / in Stock';
const PRODUCT_STATUS_UNAVAILABLE = 'Nedostupné / Not Available';

interface ICartParams {
  ids: Array<any>;
  currencyId: string;
  render: () => void;
}

const CartParams = adopt({
  attributes: <Attributes />,
  variants: ({ ids, render, currencyId }: ICartParams) => <FullVariants ids={ids} currencyId={currencyId}>{render}</FullVariants>
});

interface ICartProductsProps extends RouteComponentProps<{ language: string }> {
  items?: IProduct[];
  updateUnavailableProducts: (e: any) => void;
  hilightProducts: boolean;
}
interface ICartProductsState {
  alert: boolean;
}

@observer
class CartProducts extends React.Component<ICartProductsProps> {
  public state: ICartProductsState;
  
  constructor(props: ICartProductsProps) {
    super(props);
    this.state = {
      alert: false
    };
  }

  public toggleAlert(open: boolean) {
    this.setState({ alert: open });
  }

  public isProductUnavailable = (item: any) => {
    // NOTICE: If bug appears, we need to create special field for modal
    return item && item.product && item.product.availability &&
      (item.product.availability.name !== PRODUCT_STATUS_AVAILABLE 
        && item.product.availability.name !== PRODUCT_STATUS_UNAVAILABLE);
  }

  public updateUnavailableProducts = (products: any[]) => {
    const unavailableProductsArray = [];
    if (!Array.isArray(products)) {
      return;
    }

    for ( const item of products ) {
      if ( this.isProductUnavailable(item) ) {
        unavailableProductsArray.push(item);
      }
    }
    this.props.updateUnavailableProducts(unavailableProductsArray);
  }

  // NOTICE: If bug appears, we need to create special field for modal
  public hilightedClass = (variant: any) => {
    const { hilightProducts } = this.props;
    const available = variant && variant.product && variant.product.availability &&
    variant.product.availability.name === PRODUCT_STATUS_AVAILABLE;

    return hilightProducts && !available ? 'hilighted' : '';
  }

  public render() {
    const { VATrate, language, currency, country } = CountryService.GetInstance();

    return (
      <CartParams ids={CartService.GetInstance().getAllVariantIds()} currencyId={currency.id}>
        {({ attributes, variants }: any) => {
          if (attributes.attributes.loading || variants.fullVariants.loading) {
            return (
              <Loader />
            );
          }

          removeUnavailableItemsFromCart(variants, currency);

          const attrs = attributes.attributes.attributes;
          const fullVariants = variants.fullVariants.variants;

          this.updateUnavailableProducts(fullVariants);
          CartService.GetInstance().validateBasketStatus();

          return (
            <>

              {/* <Alert
                  type="error"
                  visible={this.state.alert}
                  onTimeout={() => {
                      this.toggleAlert(false);
                  }}
              >
                Byl dosažen počet dostupných kusů na skladě.
              </Alert> */}

              {/* Desktop košík */}
              <div className="cartProducts visible-sm">
                <table className="table table--cart">
                  <thead>
                    <tr>
                      <th colSpan={2}>Item</th>
                      <th className="text-center">Availability</th>
                      <th className="text-center">Count of pcs</th>
                      <th className="text-center hiddenMax-md">Price per unit</th>
                      <th className="text-center">Total price</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {(fullVariants || []).map((v: any) => {
                      const image = getImageFromProductByVariant(v.product, v);

                      const quantity = (
                        CartService.GetInstance().orderItems.find(o => o.variant.id == v.id) ||
                        ({} as any)
                      ).quantity;

                      // Quantity restriction & alert
                      // e.g. max quantity is 10
                      // if (quantity > v.inStock && v.product.status != 1) {
                      //   FlashStore.GetInstance().showMessage(
                      //     `Byl dosažen počet dostupných kusů na skladě.`,
                      //     'error',
                      //     20000
                      //   );
                      //   CartService.GetInstance().updateQuantity(v.id, v.inStock);
                      // } else if (quantity < v.inStock) {
                      //   if (this.state.alert) {
                      //     FlashStore.GetInstance().clearMessage();
                      //   }
                      // }

                      // atributy varianty
                      const attributeDefinition = getAttributeDefinitions(v, attrs || [], language);

                      return (
                        <tr key={v.id} className={`cartProduct ${this.hilightedClass(v)}`}>
                          <td className="text-center">
                            <div className="cartProduct__preview d-flex align-items-center">
                              <Image image={image} width={190} height={190} alt={v.product.name[language]} />
                            </div>
                          </td>
                          <td>
                            <div className="cartProduct__title">
                              <Link to={buildProductLink(v.product, undefined, v, language) || ''}>
                                {v.product.name[language]}
                              </Link><br />
                              <span>
                                <div className="productBox__code">
                                  Item number: #{v.ean}
                                </div>
                                {attributeDefinition &&
                                  <div className="productBox__definitions">
                                    {displayAttributeDefinitions(attributeDefinition)}
                                  </div>}
                              </span>
                            </div>
                          </td>
                          <td className="text-center">
                            {v.product.availability &&
                              <Availability availability={v.product.availability} />}
                          </td>
                          <td className="text-center">
                            <QuantityForm
                              onChange={newVal =>
                                CartService.GetInstance().updateQuantity(v.id, newVal)
                              }
                              value={
                                (
                                  CartService.GetInstance().orderItems.find(
                                    o => o.variant.id == v.id
                                  ) || ({} as any)
                                ).quantity
                              }
                            />
                          </td>
                          <td className="text-center cartProduct__price hiddenMax-md">
                            <div>
                              <Currency
                                    price={CartService.GetInstance().getPriceWithoutVatForVariant(v.id, true)}
                                    decimals={2}
                                  />
                              {CartService.GetInstance().getPriceForVariant(v.id, true) !== CartService.GetInstance().getPriceForVariant(v.id, false) &&
                                <Currency
                                    style={{ textDecoration: 'line-through', fontSize: '0.75em', color: 'gray', display: 'block' }}
                                    price={CartService.GetInstance().getPriceForVariant(v.id, false)}
                                  />}
                              {VATrate > 0 &&
                                <div className="withoutVat">
                                  <Currency
                                    price={CartService.GetInstance().getPriceForVariant(v.id, true)}
                                  /> incl. {vatDescription()}
                                </div>}
                            </div>
                          </td>
                          <td className="text-center cartProduct__price cartProduct__priceTotal text-bold">
                            <div>
                              <Currency
                                price={CartService.GetInstance().getTotalPriceWithoutVatForVariant(v.id, true)}
                                decimals={2}
                              />
                              {CartService.GetInstance().getTotalPriceForVariant(v.id, true) !== CartService.GetInstance().getTotalPriceForVariant(v.id, false) && 
                                <Currency
                                  style={{ textDecoration: 'line-through', fontSize: '0.75em', color: 'gray' }}
                                  price={CartService.GetInstance().getTotalPriceForVariant(v.id, false)}
                                />}
                              {VATrate > 0 &&
                                <div className="withoutVat">
                                  <Currency
                                    price={CartService.GetInstance().getTotalPriceForVariant(v.id, true)}
                                  /> incl. {vatDescription()}
                                </div>}
                            </div>
                          </td>
                          <td className="text-center">
                            <button
                              onClick={() =>
                                CartService.GetInstance().removeItemCompletelyFromCart(v.id)
                              }
                            >
                              <Icon type="delete" />
                            </button>
                          </td>
                        </tr>);
                    })}
                    {CartService.GetInstance().individualCustomerVoucherDiscount &&
                    <tr className={`cartProduct}`}>
                      <td />
                      <td>{CartService.GetInstance().voucherTitle}</td>
                      <td colSpan={3} />
                      <td className="text-center cartProduct__price cartProduct__priceTotal text-bold">
                        <div>
                          <Currency
                            price={-CartService.GetInstance().individualCustomerVoucherDiscountWithoutVat}
                            decimals={2}
                          />
                        </div>
                        {VATrate > 0 &&
                          <div className="withoutVat">
                            <Currency
                              price={-CartService.GetInstance().individualCustomerVoucherDiscount}
                            /> incl. {vatDescription()}
                          </div>}
                      </td>
                      <td className="text-center">&nbsp;</td>
                    </tr>
                    || ''}
                  </tbody>
                </table>
              </div>
            
              {/* Mobilní košík */}
              <div className="cartProducts hidden-sm">
                <table className="table table--cart">
                  <tbody>
                    {(fullVariants || []).map((v: any) => {
                      const image = getImageFromProductByVariant(v.product, v);

                      const quantity = (
                        CartService.GetInstance().orderItems.find(o => o.variant.id == v.id) ||
                        ({} as any)
                      ).quantity;

                      // Quantity restriction & alert
                      // e.g. max quantity is 10
                      // if (quantity > v.inStock && v.product.status != 1) {
                      //   FlashStore.GetInstance().showMessage(
                      //     `Byl dosažen počet dostupných kusů na skladě.`,
                      //     'error',
                      //     20000
                      //   );
                      //   CartService.GetInstance().updateQuantity(v.id, v.inStock);
                      // } else if (quantity < v.inStock) {
                      //   if (this.state.alert) {
                      //     FlashStore.GetInstance().clearMessage();
                      //   }
                      // }

                      // atributy varianty
                      const attributeDefinition = getAttributeDefinitions(v, attrs || [], language);

                      return (
                        <tr key={v.id} className={`cartProduct ${this.hilightedClass(v)}`}>
                          <td className="text-center">
                            <div className="cartProduct__preview d-flex align-items-center">
                              <Image image={image} width={190} height={190} alt={v.product.name[language]} />
                            </div>
                          </td>
                          <td>
                            <div className="cartProduct__title">
                              <Link to={buildProductLink(v.product, undefined, v, language) || ''}>
                                {v.product.name[language]}
                              </Link><br />
                              <span>
                                <div className="productBox__code">
                                  Item number: #{v.ean}
                                </div>
                                {attributeDefinition &&
                                  <div className="productBox__definitions">
                                    {displayAttributeDefinitions(attributeDefinition)}
                                  </div>}
                              </span>
                            </div>

                            <div className="cartProduct__secondRow">
                              <div className="cartProduct__quantity">
                                <QuantityForm
                                  onChange={newVal =>
                                    CartService.GetInstance().updateQuantity(v.id, newVal)
                                  }
                                  value={
                                    (
                                      CartService.GetInstance().orderItems.find(
                                        o => o.variant.id == v.id
                                      ) || ({} as any)
                                    ).quantity
                                  }
                                />
                              </div>
                              <div className="cartProduct__price">
                                <div>
                                  <Currency
                                        price={CartService.GetInstance().getTotalPriceWithoutVatForVariant(v.id, true)}
                                        decimals={2}
                                      />
                                  {CartService.GetInstance().getTotalPriceForVariant(v.id, true) !== CartService.GetInstance().getTotalPriceForVariant(v.id, false) && 
                                    <Currency
                                      style={{ textDecoration: 'line-through', fontSize: '0.75em', color: 'gray' }}
                                      price={CartService.GetInstance().getTotalPriceForVariant(v.id, false)}
                                    />}
                                  {VATrate > 0 &&
                                    <div className="withoutVat">
                                      <Currency
                                        price={CartService.GetInstance().getTotalPriceForVariant(v.id, true)}
                                      /> incl. {vatDescription()}
                                    </div>}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td className="cartProduct__remove">
                            <button
                              onClick={() =>
                                CartService.GetInstance().removeItemCompletelyFromCart(v.id)
                              }
                            >
                              <Icon type="delete" />
                            </button>
                          </td>
                        </tr>);
                    })}
                  </tbody>
                </table>
              </div>
            </>
          );
        }}
      </CartParams>);
  }
}

 export default withRouter(CartProducts);



// WEBPACK FOOTER //
// ./src/components/CartProducts/CartProducts.tsx